import { default as TagManager } from 'react-gtm-module';
import { GTM_EVENT_TYPE, GTM_VARIABLE } from '../data-types/google-tag-manager/googleTagManagerEnums';
import { LOADING_SCREEN_START_TIME } from '../data-types/local-storage/localStorageConstants';
import { DEFAULT_RETRY_INTERVAL } from '../data-types/timing/timingConstants';
import { TrackerEventParameter } from '../data-types/trackers/trackersInterfaces';
import { GTM_KEY } from '../initialisation/initialisation';

export const initialiseGTM = () => {
  if (GTM_KEY) {
    TagManager.initialize({
      gtmId: GTM_KEY,
    });
  }
};

export const trackEventGTM = (event: GTM_EVENT_TYPE, params: TrackerEventParameter) => {
  if (GTM_KEY) {
    TagManager.dataLayer({
      dataLayer: {
        event,
        ...params,
      },
    });
  }
};

export const trackLoadingTimeInGTM = (loadingFinishTime: number) => {
  const loadingStartingTime = Number(localStorage.getItem(LOADING_SCREEN_START_TIME) || new Date().getTime());

  trackEventGTM(GTM_EVENT_TYPE.LOADING_SCREEN_DURATION, {
    [GTM_VARIABLE.EVENT_VALUE]: loadingFinishTime - loadingStartingTime,
  });

  localStorage.removeItem(LOADING_SCREEN_START_TIME);
};

export const waitUntilGTMDataLayerIsDefined = (callback: () => void) => {
  if (GTM_KEY) {
    const maxIntervals = 30;
    let intervals = 0;

    const interval = setInterval(() => {
      if (intervals >= maxIntervals) {
        clearInterval(interval);
        return;
      }

      if (window.dataLayer) {
        callback();
        clearInterval(interval);
      }

      intervals += 1;
    }, DEFAULT_RETRY_INTERVAL);
  }
};
